// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.login-container {
    height: 60vh;
    margin: 8rem auto;
}

.logo img{
    width: 150px;
    height: 150px;
    position: absolute;
    /* top: 15px;
    left: 600px;    */
    top: -150px;
    left: -30px;   
}

.login-form {
    height: 60vh;
    width: 100%;
   
    max-width: 350px; 
    padding: 5rem;
    box-sizing: border-box;
    background: linear-gradient(rgb(253, 252, 252), #fffefe) padding-box, linear-gradient(105deg, transparent 55%, #f0ca4d, #f435de) border-box;
    border: 4px solid transparent;
    border-radius: 10px;
    box-shadow: 5px 10px 20px rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 10px;

   
   
}

.login-form h2 {
    font-weight: bold;
    margin-bottom: 1.5rem;
    color: rgb(5, 5, 5);
}

.login-form .form-control {
    padding-left: 2.5rem;
    margin-bottom: 1rem;
}

.login-page-btn {
    width: 8vw;
    min-width: 100px;
}

.input-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #6c757d;
}

button[disabled] {
    cursor: not-allowed;
}

@media (max-width: 768px) {
    .login-form {
        padding: 1.5rem;
        height: 50vh;
        width: 80%;
    }

    .login-container {
        margin: 10rem auto;
    }

    .login-page-btn {
        width: auto;
    }

    .logo img{
        width: 150px;
        height: 150px;
        position: absolute;
        top: -150px;
        left: -30px;
       
    
    }
}

@media (max-width: 576px) {
    .row.login-form {
        padding: 1rem;
        width: 80%;
        height: 70vh;
    }

    .row.login-container {
        height: 100%;
        margin: 8rem auto;
       
    }

    .login-page-btn {
        width: 100%;
        margin-bottom: 1rem;
    }

    .logo img{
        width: 150px;
        height: 150px;
        position: absolute;
        top: -150px;
        left: -30px;
       
    
    }

}
`, "",{"version":3,"sources":["webpack://./src/components/LoginForm.css"],"names":[],"mappings":";AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB;qBACiB;IACjB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;;IAEX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,2IAA2I;IAC3I,6BAA6B;IAC7B,mBAAmB;IACnB,4CAA4C;IAC5C,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;;;;AAIvB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;QACf,YAAY;QACZ,UAAU;IACd;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,WAAW;QACX,WAAW;;;IAGf;AACJ;;AAEA;IACI;QACI,aAAa;QACb,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,iBAAiB;;IAErB;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,WAAW;QACX,WAAW;;;IAGf;;AAEJ","sourcesContent":["\n.login-container {\n    height: 60vh;\n    margin: 8rem auto;\n}\n\n.logo img{\n    width: 150px;\n    height: 150px;\n    position: absolute;\n    /* top: 15px;\n    left: 600px;    */\n    top: -150px;\n    left: -30px;   \n}\n\n.login-form {\n    height: 60vh;\n    width: 100%;\n   \n    max-width: 350px; \n    padding: 5rem;\n    box-sizing: border-box;\n    background: linear-gradient(rgb(253, 252, 252), #fffefe) padding-box, linear-gradient(105deg, transparent 55%, #f0ca4d, #f435de) border-box;\n    border: 4px solid transparent;\n    border-radius: 10px;\n    box-shadow: 5px 10px 20px rgba(0, 0, 0, 0.5);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    border-radius: 10px;\n\n   \n   \n}\n\n.login-form h2 {\n    font-weight: bold;\n    margin-bottom: 1.5rem;\n    color: rgb(5, 5, 5);\n}\n\n.login-form .form-control {\n    padding-left: 2.5rem;\n    margin-bottom: 1rem;\n}\n\n.login-page-btn {\n    width: 8vw;\n    min-width: 100px;\n}\n\n.input-icon {\n    position: absolute;\n    left: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #6c757d;\n}\n\nbutton[disabled] {\n    cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n    .login-form {\n        padding: 1.5rem;\n        height: 50vh;\n        width: 80%;\n    }\n\n    .login-container {\n        margin: 10rem auto;\n    }\n\n    .login-page-btn {\n        width: auto;\n    }\n\n    .logo img{\n        width: 150px;\n        height: 150px;\n        position: absolute;\n        top: -150px;\n        left: -30px;\n       \n    \n    }\n}\n\n@media (max-width: 576px) {\n    .row.login-form {\n        padding: 1rem;\n        width: 80%;\n        height: 70vh;\n    }\n\n    .row.login-container {\n        height: 100%;\n        margin: 8rem auto;\n       \n    }\n\n    .login-page-btn {\n        width: 100%;\n        margin-bottom: 1rem;\n    }\n\n    .logo img{\n        width: 150px;\n        height: 150px;\n        position: absolute;\n        top: -150px;\n        left: -30px;\n       \n    \n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
